import React, { useState } from 'react'
import { BsCaretRightFill } from 'react-icons/bs'

export const FAQ = ({ faqSections }) => {
  const [openFaqs, setOpenFaqs] = useState(
    new Array(faqSections.length).fill(false),
  )

  const handleClick = (index) =>
    setOpenFaqs(openFaqs.map((faq, i) => (i === index ? !faq : faq)))

  return (
    <div className='flex flex-col pl-[24px] lg:pl-[80px] lg:py-[40px] pr-[31px] lg:pr-[40px] gap-6'>
      <h1 className='font-bold text-base lg:text-2xl tracking-wide'>FAQ</h1>
      <div className='flex flex-col gap-5 pb-6'>
        {faqSections.map(({ title, content }, i) => (
          <div
            key={title + i}
            className={`py-[24px] px-[20px] rounded-lg 
                        shadow-[0px_0.4000000059604645px_16px_0px_rgba(0,0,0,0.08)] 
                        border-[0.4px] border-[#8484f5] hover:outline hover:outline-[0.8px] hover:outline-[#8484f5]`}
          >
            <div
              className='flex justify-between items-center cursor-pointer'
              onClick={() => handleClick(i)}
            >
              <span className='font-bold text-sm lg:text-lg'>{title}</span>
              <BsCaretRightFill
                aria-label='Toggle faq'
                className={`flex-shrink-0 w-6 h-6 transition-transform duration-300 
                                    ${openFaqs[i] ? 'rotate-90' : 'rotate-0'}
                                `}
              />
            </div>
            {openFaqs[i] && (
              <span className='pt-[10px] text-sm text-[#3f5985] text-justify'>
                {content}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
